import { IModuleSchema } from '@/api/module';
import { TreeNode } from 'primereact/treenode';

export const makeModuleOptions = (datum: IModuleSchema[]): TreeNode[] => {
  const createTreeNode = (module: IModuleSchema): TreeNode => {
    return {
      key: module.id,
      label: module.module_name,
      children: module.submodule?.map(createTreeNode) || [],
    };
  };

  const modules: TreeNode[] = datum.map(createTreeNode);

  return modules;
};
